var _rect, _g, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXCircleRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_1086_6",
    "data-name": "Component 1086 \\u2013 6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15383",
    "data-name": "Rectangle 15383",
    width: 24,
    height: 24,
    transform: "translate(4 4)",
    fill: "#fff",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cancel",
    transform: "translate(7 6.931)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38167",
    "data-name": "Group 38167",
    transform: "translate(0 0.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38166",
    "data-name": "Group 38166",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58489",
    "data-name": "Path 58489",
    d: "M15.494,2.723a9.071,9.071,0,1,0,0,12.835A9.087,9.087,0,0,0,15.494,2.723ZM14.5,14.564a7.67,7.67,0,1,1,0-10.847A7.679,7.679,0,0,1,14.5,14.564Z",
    transform: "translate(0 -0.07)",
    fill: "#fd0e35"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38169",
    "data-name": "Group 38169",
    transform: "translate(5.928 5.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38168",
    "data-name": "Group 38168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58490",
    "data-name": "Path 58490",
    d: "M173.414,169.988,171.424,168l1.99-1.987a.7.7,0,1,0-.994-.995l-1.992,1.989-1.992-1.989a.7.7,0,1,0-.994.995l1.99,1.987-1.99,1.987a.7.7,0,0,0,.994.995l1.992-1.989,1.992,1.989a.7.7,0,1,0,.994-.995Z",
    transform: "translate(-167.236 -164.813)",
    fill: "#fd0e35"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1648",
    "data-name": "Ellipse 1648",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#fd0e35",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircleRed);
export default __webpack_public_path__ + "static/media/x-circle-red.e707f95f92297e89471b17fb4f55eaca.svg";
export { ForwardRef as ReactComponent };